import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const BoxStarSVG = ({
  fill = 'currentColor',
  size = '12',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <rect width="20" height="20" rx="6" fill="#7358E9" />
      <path
        d="M9.52447 3.46352C9.67415 3.00287 10.3259 3.00287 10.4755 3.46353L11.6839 7.18237C11.7508 7.38838 11.9428 7.52786 12.1594 7.52786H16.0696C16.554 7.52786 16.7554 8.14767 16.3635 8.43237L13.2001 10.7307C13.0248 10.8581 12.9515 11.0838 13.0184 11.2898L14.2268 15.0086C14.3764 15.4693 13.8492 15.8523 13.4573 15.5676L10.2939 13.2693C10.1186 13.1419 9.88135 13.1419 9.70611 13.2693L6.54267 15.5676C6.15081 15.8523 5.62357 15.4693 5.77325 15.0086L6.98157 11.2898C7.04851 11.0838 6.97518 10.8581 6.79994 10.7307L3.6365 8.43237C3.24464 8.14767 3.44603 7.52786 3.93039 7.52786H7.84062C8.05723 7.52786 8.24921 7.38838 8.31614 7.18237L9.52447 3.46352Z"
        fill="white"
      />
    </svg>
  </span>
);

export default BoxStarSVG;
